import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SlopedRightRectangleDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'sloped-right-rectangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => {
	if (isCutout) {
		return store.getters.isShapeValid(isCutout) && store.getters.isCutoutGroupValid;
	}

	return store.getters.isShapeValid() && store.getters.isGroupValid;
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});

const widthTop = computed({
	get: () => dimensions.value.width_top,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width_top",
			value: value,
		});
	},
});

const widthBottom = computed({
	get: () => dimensions.value.width_bottom,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width_bottom",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "sloped-right-rectangle-height",
        id: `${_ctx.prefix}measurements-sloped-right-rectangle-height`,
        name: `${_ctx.prefix}measurements[dimensions][height]`,
        unit: "cm",
        label: dimensionLabel.value('height', 'sloped-right-rectangle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}sloped-right-rectangle-height`),
        onBlur: () => _unref(addSizeToDataLayer)('height', +height.value, 'sloped-right-rectangle'),
        modelValue: height.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((height).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "sloped-right-rectangle-width_top",
        id: `${_ctx.prefix}measurements-sloped-right-rectangle-width_top`,
        name: `${_ctx.prefix}measurements[dimensions][width_top]`,
        unit: "cm",
        label: dimensionLabel.value('width_top', 'sloped-right-rectangle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width_top'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}sloped-right-rectangle-width_top`),
        onBlur: 
				() => _unref(addSizeToDataLayer)('width_top', +widthTop.value, 'sloped-right-rectangle')
			,
        modelValue: widthTop.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((widthTop).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "sloped-right-rectangle-width_bottom",
        id: `${_ctx.prefix}measurements-sloped-right-rectangle-width_bottom`,
        name: `${_ctx.prefix}measurements[dimensions][width_bottom]`,
        unit: "cm",
        label: dimensionLabel.value('width_bottom', 'sloped-right-rectangle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width_bottom'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}sloped-right-rectangle-width_bottom`),
        onBlur: 
				() => _unref(addSizeToDataLayer)('width_bottom', +widthBottom.value, 'sloped-right-rectangle')
			,
        modelValue: widthBottom.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((widthBottom).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})